import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="module-storage-entry" id="module-storage-entry"></a>
    <h1 {...{
      "id": "entry"
    }}>{`Entry`}</h1>
    <p>{`An `}<inlineCode parentName="p">{`Entry`}</inlineCode>{` is the base class for `}<inlineCode parentName="p">{`File`}</inlineCode>{` and `}<inlineCode parentName="p">{`Folder`}</inlineCode>{`.
You can get an instance of Entry via the `}<inlineCode parentName="p">{`localFileSystem`}</inlineCode>{` by fetching an instance of a File or Folder`}</p>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Since Entry cannot be called directly we can use a File or Folder object to invoke Entry as shown below
const fs =  require('uxp').storage.localFileSystem;
const folder = await fs.getPluginFolder(); // returns a Folder instance
const folderEntry = await folder.getEntry("entryName.txt");

// Now we can use folderEntry to invoke the APIs provided by Entry
console.log(folderEntry.isEntry); // isEntry is an API of Entry, in this example it will return true
`}</code></pre>
    <a name="module-storage-entry-isentry" id="module-storage-entry-isentry"></a>
    <h2 {...{
      "id": "isentry--boolean"
    }}>{`isEntry : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p>{`Indicates that this instance is an `}<inlineCode parentName="p">{`Entry`}</inlineCode>{`. Useful for type-checking.`}</p>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`if (something.isEntry) {
    return something.getMetadata();
}
`}</code></pre>
    <a name="module-storage-entry-isfile" id="module-storage-entry-isfile"></a>
    <h2 {...{
      "id": "isfile--boolean"
    }}>{`isFile : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Indicates that this instance is `}<strong parentName="p">{`not`}</strong>{` a `}<inlineCode parentName="p">{`File`}</inlineCode>{`. Useful for type-
checking.`}</p>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`if (!anEntry.isFile) {
    return "This entry is not a file.";
}
`}</code></pre>
    <a name="module-storage-entry-isfolder" id="module-storage-entry-isfolder"></a>
    <h2 {...{
      "id": "isfolder--boolean"
    }}>{`isFolder : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Indicates that this instance is `}<strong parentName="p">{`not`}</strong>{` a folder. Useful for type-
checking.`}</p>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`if (!anEntry.isFolder) {
    return "This entry is not a folder.";
}
`}</code></pre>
    <a name="module-storage-entry-name" id="module-storage-entry-name"></a>
    <h2 {...{
      "id": "name--string"
    }}>{`name : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
The name of this entry. Read-only.`}</p>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`console.log(anEntry.name);
`}</code></pre>
    <a name="module-storage-entry-provider" id="module-storage-entry-provider"></a>
    <h2 {...{
      "id": "provider--filesystemprovider"
    }}>{`provider : `}<inlineCode parentName="h2">{`FileSystemProvider`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
The associated provider that services this entry. Read-only.`}</p>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`if (entryOne.provider !== entryTwo.provider) {
    throw new Error("Providers are not the same");
}
`}</code></pre>
    <a name="module-storage-entry-url" id="module-storage-entry-url"></a>
    <h2 {...{
      "id": "url--string"
    }}>{`url : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
The url of this entry. You can use this url as input to other entities of the extension system like for eg: set as src attribute of a Image widget in UI. Read-only.`}</p>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`console.log(anEntry.url);
`}</code></pre>
    <a name="module-storage-entry-nativepath" id="module-storage-entry-nativepath"></a>
    <h2 {...{
      "id": "nativepath--string"
    }}>{`nativePath : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
The platform native file-system path of this entry. Read-only`}</p>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`console.log(anEntry.nativePath);
`}</code></pre>
    <a name="module-storage-entry-tostring" id="module-storage-entry-tostring"></a>
    <h2 {...{
      "id": "tostring"
    }}>{`toString()`}</h2>
    <p>{`Returns the details of the given entry like name, type and native path in a readable string format.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{`  `}</p>
    <a name="module-storage-entry-copyto" id="module-storage-entry-copyto"></a>
    <h2 {...{
      "id": "copytofolder-options"
    }}>{`copyTo(folder, options)`}</h2>
    <p>{`Copies this entry to the specified `}<inlineCode parentName="p">{`folder`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<File | Folder>`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`EntryExists`}</inlineCode>{` if the attempt would overwrite an entry and `}<inlineCode parentName="li">{`overwrite`}</inlineCode>{` is `}<inlineCode parentName="li">{`false`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`PermissionDenied`}</inlineCode>{` if the underlying file system rejects the attempt`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`OutOfSpace`}</inlineCode>{` if the file system is out of storage space`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`folder`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Folder`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the folder to which to copy this entry`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.overwrite]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`if `}<inlineCode parentName="td">{`true`}</inlineCode>{`, allows overwriting existing entries`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.allowFolderCopy]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`if `}<inlineCode parentName="td">{`true`}</inlineCode>{`, allows copying the folder`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`await someFile.copyTo(someFolder);
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`await someFile.copyTo(someFolder, {overwrite: true});
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`await someFolder.copyTo(anotherFolder, {overwrite: true, allowFolderCopy: true});
`}</code></pre>
    <a name="module-storage-entry-moveto" id="module-storage-entry-moveto"></a>
    <h2 {...{
      "id": "movetofolder-options"
    }}>{`moveTo(folder, options)`}</h2>
    <p>{`Moves this entry to the target folder, optionally specifying a new name.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<void>`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`folder`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Folder`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the folder to which to move this entry`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.overwrite]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If `}<inlineCode parentName="td">{`true`}</inlineCode>{` allows the move to overwrite existing files`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.newName]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If specified, the entry is renamed to this name`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`await someFile.moveTo(someFolder);
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`await someFile.moveTo(someFolder, {overwrite: true});
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`await someFolder.moveTo(anotherFolder, {overwrite: true});
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`await someFile.moveTo(someFolder, {newName: 'masterpiece.txt'})
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`await someFile.moveTo(someFolder, {newName: 'novel.txt', {overwrite: true})
`}</code></pre>
    <a name="module-storage-entry-delete" id="module-storage-entry-delete"></a>
    <h2 {...{
      "id": "delete"
    }}>{`delete()`}</h2>
    <p>{`Removes this entry from the file system. If the entry is a folder, it must be empty before deletion.
Note: Currently when using this method, a permission denied error will occur if attempting to delete
a folder that was selected from a storage picker or added via drag-and-drop.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<number>`}</inlineCode>{` - the number is 0 if succeeded, otherwise throws an Error`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`await aFile.delete();
`}</code></pre>
    <a name="module-storage-entry-getmetadata" id="module-storage-entry-getmetadata"></a>
    <h2 {...{
      "id": "getmetadata"
    }}>{`getMetadata()`}</h2>
    <p>{`Returns this entry's metadata.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<EntryMetadata>`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const metadata = aFile.getMetadata();
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      